// src/hooks/common/useConfirm.ts
import {useSelector, useDispatch} from "react-redux";
import {useCallback} from "react";
import {
  selectConfirmDialog,
  showConfirmDialog,
  hideConfirmDialog,
} from "../../store/slices/uiSlice";

interface ConfirmOptions {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: "danger" | "warning" | "info";
}

export const useConfirm = () => {
  const dispatch = useDispatch();
  const confirmDialog = useSelector(selectConfirmDialog);

  const confirm = useCallback(
    (options: ConfirmOptions): Promise<boolean> => {
      return new Promise((resolve) => {
        dispatch(
          showConfirmDialog({
            ...options,
            onConfirm: () => {
              dispatch(hideConfirmDialog());
              resolve(true);
            },
            onCancel: () => {
              dispatch(hideConfirmDialog());
              resolve(false);
            },
          })
        );
      });
    },
    [dispatch]
  );

  const hide = useCallback(() => {
    dispatch(hideConfirmDialog());
  }, [dispatch]);

  return {
    confirmDialog,
    confirm,
    hide,
  };
};
